var map = {
	"./A1.svg": "sOFW",
	"./A2.svg": "D/cx",
	"./A3.svg": "SXEI",
	"./A4.svg": "SIxw",
	"./A5.svg": "7hyN",
	"./A6.svg": "6NJv",
	"./A7.svg": "ZHnx",
	"./A8.svg": "JSk2",
	"./A9.svg": "l3fJ",
	"./BTC-g.svg": "IW7s",
	"./BTC-r.svg": "SKYy",
	"./BTC-y.svg": "gk7n",
	"./BTC.svg": "RP0o",
	"./SVIP.svg": "4lTQ",
	"./V1.svg": "eSOr",
	"./V2.svg": "JUCb",
	"./binance.svg": "dwsV",
	"./brti-data.svg": "NmET",
	"./bybit.svg": "jgHI",
	"./default-page.svg": "GaWe",
	"./default-photo-te.svg": "esdc",
	"./default-photo.svg": "V1nQ",
	"./delete.svg": "vQyv",
	"./deribit.svg": "hSMa",
	"./discord.svg": "l3ik",
	"./down.svg": "CwQg",
	"./ftx.svg": "Ylxe",
	"./headerLogo.svg": "cCsQ",
	"./info.svg": "urB+",
	"./issue.svg": "Mou9",
	"./list.svg": "ngqd",
	"./logo-beta.svg": "2hSB",
	"./okx.svg": "+OI/",
	"./pie.svg": "ToAo",
	"./private-letter-y-o.svg": "+seR",
	"./private-letter-y.svg": "+Wh8",
	"./question-o.svg": "GkMO",
	"./question.svg": "V5ra",
	"./rtaLogo.svg": "xkx5",
	"./select-expend.svg": "NcKF",
	"./select-up.svg": "8lk5",
	"./telegram.svg": "fLcw",
	"./tradingview.svg": "PSKS",
	"./twitter.svg": "kgBd",
	"./up.svg": "Kzun",
	"./venture.svg": "wCGv",
	"./ventures.svg": "nBeD",
	"./youtube.svg": "+BhO",
	"./超级会员.svg": "wHDJ",
	"./高级会员V1.svg": "zIv5",
	"./高级会员V2.svg": "wqfg"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1ULS";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rtaLogo ^\.\/.*\.svg$
// module id = 1ULS
// module chunks = 1